import type { ReactNode } from 'react'

export function QueueTable({ children }: { children: ReactNode }): JSX.Element {
  return <div className="queue-table">{children}</div>
}

export function QueueRow({
  selected = false,
  children,
}: {
  selected?: boolean
  children: ReactNode
}): JSX.Element {
  // La selezione si dice, non solo si dipinge: lo sfondo da solo non arriva
  // a chi non vede il contrasto o usa un lettore di schermo.
  return (
    <div className={selected ? 'queue-row sel' : 'queue-row'} aria-current={selected ? 'true' : undefined}>
      {children}
    </div>
  )
}
